<sabis-ngx-dialog [scTitle]="title">

  <div modal-body class="sc-inputs-dialog">
    <!-- header message -->
    @for (message of messages; track message) {
      <p style="word-break: break-word">
        {{ message }}
      </p>
    }

    <!-- parts -->
    @for (part of parts; track part) {
      <div>
        <!-- text -->
        @if (part.type === 'text') {
          <sabis-ngx-input
            [scLabel]="part.label"
            type="text"
            [ngModel]="part.value"
            (ngModelChange)="onModelChange($event, part)"
            [required]="part.required ?? false" />
        }
        <!-- text-area -->
        @if (part.type === 'multiline') {
          <sabis-ngx-textarea
            [scLabel]="part.label"
            [scCols]="100"
            [scRows]="10"
            [ngModel]="part.value"
            (ngModelChange)="onModelChange($event, part)"
            [required]="part.required ?? false" />
        }
        <!-- date -->
        @if (part.type === 'date') {
          <sabis-ngx-datepicker
            [scLabel]="part.label"
            [ngModel]="part.value"
            [min]="part.minDate"
            [max]="part.maxDate"
            (ngModelChange)="onModelChange($event, part)"
            [required]="part.required ?? false" />
        }
        <!-- file picker -->
        @if (part.type === 'file') {
          <section>
            <sabis-ngx-filepicker [uploader]="part.uploaderService!"
              [files]="part.value"
              [directoryPath]="part.fileDirectoryPath!"
            (fileChanged)="onModelChange($event, part)"></sabis-ngx-filepicker>
          </section>
        }
      </div>
    }
  </div>
  <div modal-footer>
    @for (button of buttons; track button) {
      <sabis-ngx-button (click)="onActionButtonClick(button)">
        {{ button.name }}
      </sabis-ngx-button>
    }
  </div>

</sabis-ngx-dialog>
